export default {"src":"/_next/static/media/usa-flag.205eaaca.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};